<template>
  <el-dialog
    title="事项类型"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :model="formInline"
        ref="form"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="事项类型" prop="sxlx">
          <el-input
            :disabled="!!formInline.id"
            v-model="formInline.sxlx"
            placeholder="事项类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch
            v-model="formInline.state"
            :disabled="!!formInline.id"
            active-value="是"
            inactive-value="否"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="任务大类" prop="state">
          <el-select
            filterable
            placeholder="请选择任务大类"
            clearable
            :disabled="!!formInline.id"
            v-model="formInline.superFlag"
          >
            <el-option
              v-for="item in sfyjsxOptions"
              :key="item.data.itemLabel"
              :label="item.data.itemName"
              :value="item.data.itemLabel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="
            checkRole('GLLD') && formInline.superFlag == 'EVENT_TYPE_TYPE_FRC'
          "
          label="主办部门"
          prop="tjDeptId"
        >
          <el-select
            v-model="formInline.tjDeptId"
            @change="getUserList"
            placeholder="请选择"
            :disabled="!!formInline.id"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="
            formInline.tjDeptId && formInline.superFlag == 'EVENT_TYPE_TYPE_FRC'
          "
          label="主办人员"
          prop="adminUsers"
        >
          <el-select
            v-model="formInline.adminUsers"
            placeholder="请选择"
            multiple
          >
            <el-option
              v-for="item in userList"
              :key="item.userid"
              :value="item.userid"
              :label="item.username"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="editFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { edit } from "@/api/base.js";
import {
  dictItemRoot,
  getDeptTree,
  getUserList2
} from "@/api/systemManagement.js";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      userList: [],
      deptList: [],
      formInline: {
        tjDeptId: "",
        sxlx: "",
        sfyjsx: "否",
        state: "是",
        id: "",
        superFlag: "",
        adminUsers: []
      },
      rules: {
        sxlx: [{ required: true, message: "请输入事项类型", trigger: "blur" }],
        sfyjsx: [
          { required: true, message: "请选择是否应急事项", trigger: "blur" }
        ],
        state: [{ required: true, message: "请选择是否启用", trigger: "blur" }],
        tjDeptId: [{ required: true, message: "请选择部门", trigger: "blur" }],
        adminUsers: [
          { required: true, message: "请选择人员", trigger: "change" }
        ]
      },
      sfyjsxOptions: []
    };
  },
  mounted() {
    if (this.curItem && this.curItem.id) {
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
      this.$nextTick(() => {
        this.formInline.adminUsers = this.formInline.adminList.map(
          item => item.userId
        );
      });
    }
    console.log(this.formInline, "formInline");
    console.log(!this.formInline.id, "formInline");

    if (!this.checkRole("GLLD")) {
      this.formInline.tjDeptId = this.getDeptId();
    }
    this.dictItemRootFun();
    this.getTree();
    this.getUserList();
  },
  methods: {
    async getUserList() {
      const { data } = await getUserList2({
        page: 1,
        size: 999,
        deptId: this.formInline.tjDeptId,
        zcUserTypeLike: "gov"
      }).then(res => res.data);
      this.userList = data.dataList.map(item => ({
        userid: item.id,
        username: item.userName
      }));
    },
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    checkRole(roleCode) {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        const role = userInfo.roles.find(role => role.roleCode === roleCode);
        return role ? true : false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    getDeptId() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        return userInfo.deptId;
      } catch (error) {
        console.error(error);
        return "";
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async editFun(submitFlag) {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        sxlx: this.formInline.sxlx,
        sfyjsx: this.formInline.sfyjsx,
        state: this.formInline.state,
        id: this.formInline.id,
        superFlag: this.formInline.superFlag
      };
      if (this.formInline.superFlag == "EVENT_TYPE_TYPE_FRC") {
        params.tjDeptId = this.formInline.tjDeptId || this.getDeptId();
        let adminUsers = [];
        if (this.formInline.adminUsers.length > 0) {
          adminUsers = this.userList.filter(item =>
            this.formInline.adminUsers.includes(item.userid)
          );
        }
        params.adminUsers = adminUsers;
      }
      const res = await edit(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async dictItemRootFun() {
      const { data } = await dictItemRoot({
        dictType: "EVENT_TYPE_TYPE",
        data: true,
        pid: -1,
        page: 1,
        size: 9999
      });
      this.sfyjsxOptions = data.data.dataList || [];
    }
  },
  computed: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  // width: 340px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesManagement/components/typeDialog.vue